import { renderToDom } from '@dock/dom';

import App from './App';
import { initSentry } from './configs/sentry';

initSentry();

renderToDom(<App />);
